/**
 *
 * SelectUsers
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { array } from 'yup';
import { FormattedMessage } from 'react-intl';
import { Alert, Modal, Nav } from 'react-bootstrap';
import { getIdNumber } from 'utils/userIdRole.js';
import { USERROLES } from 'containers/User/constants.js';
import PrimaryAction from '../PrimaryAction/index.jsx';
import UserTags from './UserTags.jsx';
import UserSelector from './UserSelector.jsx';
import messages from './messages.js';

const ModalHeader = styled(Modal.Header)`
  &.modal-header {
    min-height: 64px;
    max-height: 120px;
    overflow-y: auto;
    h4 {
      line-height: 14px;
    }
  }
`;

function SelectUsers(props) {
  const {
    show, onChange, onHide, onBlur, submitText = messages.save, defaultRole, setDefaultRole, prompt = messages.prompt, exclusions, required, roles = USERROLES, value: initialValue = [], ...rest
  } = props;
  const [value, setValue] = useState(initialValue);
  const [submitted, setSubmitted] = useState(false);
  const [activeRole, setActiveRole] = useState(defaultRole || roles?.[0]?.id);
  function setDefaultAndActiveRole(role) {
    setActiveRole(role);
    if (setDefaultRole) {
      setDefaultRole(role);
    }
  }
  const activeRoleType = roles?.find((r) => r.id === activeRole);
  const initialValueString = initialValue?.map(getIdNumber).join(',');
  useEffect(() => setValue(initialValue), [initialValueString]); // eslint-disable-line react-hooks/exhaustive-deps
  const requiredError = required && value.length === 0;

  function handleHide(val) {
    if (onBlur) {
      onBlur();
    }
    if (!val) {
      setValue(initialValue);
    }
    onHide(val);
  }

  function handleSubmit() {
    setSubmitted(true);
    if (requiredError) {
      return;
    }
    onChange(value);
    handleHide(true);
  }

  return (
    <Modal show={show} onHide={() => handleHide(false)}>
      <ModalHeader>
        <UserTags value={value} onChange={setValue} exclusions={exclusions} prompt={prompt} />
      </ModalHeader>
      {submitted && requiredError && <Alert variant="danger" className="mx-4 my-3"><FormattedMessage {...messages.atLeastOne} /></Alert>}
      {roles && roles.length > 1 && (
        <Nav activeKey={activeRole} className="socs-tabs px-4">
          {roles.map((roleType) => (
            <Nav.Item key={roleType.id}>
              <Nav.Link eventKey={roleType.id} onClick={() => setDefaultAndActiveRole(roleType.id)}>
                <FormattedMessage {...(roleType.label || messages[roleType.name])} />
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      )}
      <UserSelector roleType={activeRoleType} value={value} exclusions={exclusions} onChange={setValue} {...rest} />
      <Modal.Footer>
        <PrimaryAction onCancel={() => handleHide(false)} onSubmit={handleSubmit} submitText={submitText} />
      </Modal.Footer>
    </Modal>
  );
}

SelectUsers.propTypes = {
  show: PropTypes.bool,
  value: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  submitText: PropTypes.object,
  onHide: PropTypes.func,
  defaultRole: PropTypes.number,
  setDefaultRole: PropTypes.func,
  roles: PropTypes.array,
  required: PropTypes.bool,
  exclusions: PropTypes.array,
  tabKey: PropTypes.string,
  prompt: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

SelectUsers.getSchema = () => array();

export default SelectUsers;
